import * as commonDataIds from './common';
import * as settlementsDataIds from './settlements';
import * as txnHistoryDataIds from './transactionHistory';
import * as bulkRefundDataIds from './bulkRefunds';
import * as refundsHistoryDataIds from './refundHistory';
import * as filterModalDataIds from './filterModal';
import * as dailyReportsIds from './dailyReports';
export const DATA_IDS = {
    ...commonDataIds,
    ...settlementsDataIds,
    ...txnHistoryDataIds,
    ...bulkRefundDataIds,
    ...commonDataIds,
    ...refundsHistoryDataIds,
    ...filterModalDataIds,
    ...dailyReportsIds,
};
